import React from 'react'

import progress from '../Contents/images/utils/progress.gif'
import { useStateValue } from '../Utils/StateProvider'

function ProcessScreen() {
    const [{processPercent}] = useStateValue()
    return (
        <div className='process-screen'>
            <img src={progress} alt="processing..." />
            {/* {
                processPercent > 0 && (
                    <div className="progress">
                        <div className="fill stroke" style={{width: `${processPercent}%`}}>
                            <span>{processPercent}%</span>
                        </div>
                    </div>
                )
            } */}
        </div>
    )
}

export default ProcessScreen
